export function normalizeDatasetId(value) {
  if (value == null) return "";
  const s = String(value).trim();
  if (!s || s === "undefined" || s === "null") return "";
  return s;
}

export function normalizeTaxYear(value) {
  if (value == null) return "";
  const s = String(value).trim();
  return /^\d{4}$/.test(s) ? s : "";
}

/**
 * Resolve dataset id + tax year from route, router state, cached dataset meta,
 * and loaded analysis/snapshot payload (same fallbacks as runBackendAnalysis).
 */
export function resolveDatasetAnalysisContext({
  actualDatasetId,
  locationState = {},
  locationSearch = "",
  userDataset = null,
  backendData = null,
  finalYear = "",
  routeStateYear = "",
  storedTaxYear = "",
} = {}) {
  const root =
    backendData?.analysisResult ??
    backendData ??
    null;

  const ds =
    backendData?.analysisResult?.dataset ??
    backendData?.dataset ??
    root?.dataset ??
    null;

  const bvMeta = backendData?.balanceVerifier?.meta ?? root?.balanceVerifier?.meta ?? null;

  let queryYear = "";
  try {
    queryYear = normalizeTaxYear(new URLSearchParams(locationSearch).get("year"));
  } catch {
    queryYear = "";
  }

  const datasetId = normalizeDatasetId(
    actualDatasetId ||
      locationState?.datasetId ||
      userDataset?.id ||
      backendData?.datasetId ||
      backendData?.purchaseId ||
      root?.datasetId ||
      root?.meta?.datasetId ||
      bvMeta?.datasetId ||
      ds?.datasetId ||
      ds?.purchaseId ||
      ds?.id
  );

  const year = normalizeTaxYear(
    finalYear ||
      routeStateYear ||
      queryYear ||
      storedTaxYear ||
      userDataset?.year ||
      backendData?.year ||
      root?.year ||
      root?.meta?.year ||
      bvMeta?.year ||
      ds?.year ||
      ds?.purchaseYear ||
      ds?.datasetYear
  );

  return { datasetId, year };
}

export function missingAnalysisContextMessage({ datasetId, year, language = "de" } = {}) {
  const missing = [];
  if (!datasetId) {
    missing.push(language === "en" ? "dataset" : "Dataset");
  }
  if (!year) missing.push(language === "en" ? "tax year" : "Steuerjahr");

  if (missing.length === 0) return "";

  if (language === "en") {
    return `${missing.join(" and ")} missing.`;
  }

  if (missing.length === 2) {
    return "Dataset und Steuerjahr fehlen.";
  }

  return `${missing[0]} fehlt.`;
}
